/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Interop {
    angular.module("meevo.plugins.interop", []);
}
